"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orders = exports.OrderIDs = exports.OrderIDsForMarket = exports.OrdersForMarket = exports.DBOrder = exports.Order = exports.Params = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const coin_1 = require("../cosmos/base/v1beta1/coin");
const timestamp_1 = require("../google/protobuf/timestamp");
exports.protobufPackage = "Switcheo.carbon.order";
const baseParams = { maxReferralCommission: 0 };
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.maxReferralCommission !== 0) {
            writer.uint32(8).uint32(message.maxReferralCommission);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxReferralCommission = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseParams);
        message.maxReferralCommission =
            object.maxReferralCommission !== undefined &&
                object.maxReferralCommission !== null
                ? Number(object.maxReferralCommission)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.maxReferralCommission !== undefined &&
            (obj.maxReferralCommission = message.maxReferralCommission);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseParams);
        message.maxReferralCommission = (_a = object.maxReferralCommission) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
const baseOrder = {
    id: "",
    blockHeight: long_1.default.ZERO,
    triggeredBlockHeight: long_1.default.ZERO,
    address: "",
    market: "",
    side: "",
    price: "",
    quantity: "",
    available: "",
    filled: "",
    status: "",
    orderType: "",
    initiator: "",
    timeInForce: "",
    stopPrice: "",
    triggerType: "",
    isLiquidation: false,
    isPostOnly: false,
    isReduceOnly: false,
    poolId: long_1.default.UZERO,
    avgFilledPrice: "",
    referralAddress: "",
    referralCommission: 0,
    referralKickback: 0,
};
exports.Order = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (!message.blockHeight.isZero()) {
            writer.uint32(16).int64(message.blockHeight);
        }
        if (message.blockCreatedAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.blockCreatedAt), writer.uint32(26).fork()).ldelim();
        }
        if (!message.triggeredBlockHeight.isZero()) {
            writer.uint32(32).int64(message.triggeredBlockHeight);
        }
        if (message.address !== "") {
            writer.uint32(42).string(message.address);
        }
        if (message.market !== "") {
            writer.uint32(50).string(message.market);
        }
        if (message.side !== "") {
            writer.uint32(58).string(message.side);
        }
        if (message.price !== "") {
            writer.uint32(66).string(message.price);
        }
        if (message.quantity !== "") {
            writer.uint32(74).string(message.quantity);
        }
        if (message.available !== "") {
            writer.uint32(82).string(message.available);
        }
        if (message.filled !== "") {
            writer.uint32(90).string(message.filled);
        }
        if (message.status !== "") {
            writer.uint32(98).string(message.status);
        }
        if (message.orderType !== "") {
            writer.uint32(106).string(message.orderType);
        }
        if (message.initiator !== "") {
            writer.uint32(114).string(message.initiator);
        }
        if (message.timeInForce !== "") {
            writer.uint32(122).string(message.timeInForce);
        }
        if (message.stopPrice !== "") {
            writer.uint32(130).string(message.stopPrice);
        }
        if (message.triggerType !== "") {
            writer.uint32(138).string(message.triggerType);
        }
        if (message.allocatedMargin !== undefined) {
            coin_1.Coin.encode(message.allocatedMargin, writer.uint32(146).fork()).ldelim();
        }
        if (message.isLiquidation === true) {
            writer.uint32(152).bool(message.isLiquidation);
        }
        if (message.isPostOnly === true) {
            writer.uint32(160).bool(message.isPostOnly);
        }
        if (message.isReduceOnly === true) {
            writer.uint32(168).bool(message.isReduceOnly);
        }
        if (!message.poolId.isZero()) {
            writer.uint32(176).uint64(message.poolId);
        }
        if (message.avgFilledPrice !== "") {
            writer.uint32(186).string(message.avgFilledPrice);
        }
        if (message.referralAddress !== "") {
            writer.uint32(194).string(message.referralAddress);
        }
        if (message.referralCommission !== 0) {
            writer.uint32(200).uint32(message.referralCommission);
        }
        if (message.referralKickback !== 0) {
            writer.uint32(208).uint32(message.referralKickback);
        }
        if (message.poolRoute.length !== 0) {
            writer.uint32(218).bytes(message.poolRoute);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseOrder);
        message.poolRoute = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.blockHeight = reader.int64();
                    break;
                case 3:
                    message.blockCreatedAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.triggeredBlockHeight = reader.int64();
                    break;
                case 5:
                    message.address = reader.string();
                    break;
                case 6:
                    message.market = reader.string();
                    break;
                case 7:
                    message.side = reader.string();
                    break;
                case 8:
                    message.price = reader.string();
                    break;
                case 9:
                    message.quantity = reader.string();
                    break;
                case 10:
                    message.available = reader.string();
                    break;
                case 11:
                    message.filled = reader.string();
                    break;
                case 12:
                    message.status = reader.string();
                    break;
                case 13:
                    message.orderType = reader.string();
                    break;
                case 14:
                    message.initiator = reader.string();
                    break;
                case 15:
                    message.timeInForce = reader.string();
                    break;
                case 16:
                    message.stopPrice = reader.string();
                    break;
                case 17:
                    message.triggerType = reader.string();
                    break;
                case 18:
                    message.allocatedMargin = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 19:
                    message.isLiquidation = reader.bool();
                    break;
                case 20:
                    message.isPostOnly = reader.bool();
                    break;
                case 21:
                    message.isReduceOnly = reader.bool();
                    break;
                case 22:
                    message.poolId = reader.uint64();
                    break;
                case 23:
                    message.avgFilledPrice = reader.string();
                    break;
                case 24:
                    message.referralAddress = reader.string();
                    break;
                case 25:
                    message.referralCommission = reader.uint32();
                    break;
                case 26:
                    message.referralKickback = reader.uint32();
                    break;
                case 27:
                    message.poolRoute = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseOrder);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.blockHeight =
            object.blockHeight !== undefined && object.blockHeight !== null
                ? long_1.default.fromString(object.blockHeight)
                : long_1.default.ZERO;
        message.blockCreatedAt =
            object.blockCreatedAt !== undefined && object.blockCreatedAt !== null
                ? fromJsonTimestamp(object.blockCreatedAt)
                : undefined;
        message.triggeredBlockHeight =
            object.triggeredBlockHeight !== undefined &&
                object.triggeredBlockHeight !== null
                ? long_1.default.fromString(object.triggeredBlockHeight)
                : long_1.default.ZERO;
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.market =
            object.market !== undefined && object.market !== null
                ? String(object.market)
                : "";
        message.side =
            object.side !== undefined && object.side !== null
                ? String(object.side)
                : "";
        message.price =
            object.price !== undefined && object.price !== null
                ? String(object.price)
                : "";
        message.quantity =
            object.quantity !== undefined && object.quantity !== null
                ? String(object.quantity)
                : "";
        message.available =
            object.available !== undefined && object.available !== null
                ? String(object.available)
                : "";
        message.filled =
            object.filled !== undefined && object.filled !== null
                ? String(object.filled)
                : "";
        message.status =
            object.status !== undefined && object.status !== null
                ? String(object.status)
                : "";
        message.orderType =
            object.orderType !== undefined && object.orderType !== null
                ? String(object.orderType)
                : "";
        message.initiator =
            object.initiator !== undefined && object.initiator !== null
                ? String(object.initiator)
                : "";
        message.timeInForce =
            object.timeInForce !== undefined && object.timeInForce !== null
                ? String(object.timeInForce)
                : "";
        message.stopPrice =
            object.stopPrice !== undefined && object.stopPrice !== null
                ? String(object.stopPrice)
                : "";
        message.triggerType =
            object.triggerType !== undefined && object.triggerType !== null
                ? String(object.triggerType)
                : "";
        message.allocatedMargin =
            object.allocatedMargin !== undefined && object.allocatedMargin !== null
                ? coin_1.Coin.fromJSON(object.allocatedMargin)
                : undefined;
        message.isLiquidation =
            object.isLiquidation !== undefined && object.isLiquidation !== null
                ? Boolean(object.isLiquidation)
                : false;
        message.isPostOnly =
            object.isPostOnly !== undefined && object.isPostOnly !== null
                ? Boolean(object.isPostOnly)
                : false;
        message.isReduceOnly =
            object.isReduceOnly !== undefined && object.isReduceOnly !== null
                ? Boolean(object.isReduceOnly)
                : false;
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.avgFilledPrice =
            object.avgFilledPrice !== undefined && object.avgFilledPrice !== null
                ? String(object.avgFilledPrice)
                : "";
        message.referralAddress =
            object.referralAddress !== undefined && object.referralAddress !== null
                ? String(object.referralAddress)
                : "";
        message.referralCommission =
            object.referralCommission !== undefined &&
                object.referralCommission !== null
                ? Number(object.referralCommission)
                : 0;
        message.referralKickback =
            object.referralKickback !== undefined && object.referralKickback !== null
                ? Number(object.referralKickback)
                : 0;
        message.poolRoute =
            object.poolRoute !== undefined && object.poolRoute !== null
                ? bytesFromBase64(object.poolRoute)
                : new Uint8Array();
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.blockHeight !== undefined &&
            (obj.blockHeight = (message.blockHeight || long_1.default.ZERO).toString());
        message.blockCreatedAt !== undefined &&
            (obj.blockCreatedAt = message.blockCreatedAt.toISOString());
        message.triggeredBlockHeight !== undefined &&
            (obj.triggeredBlockHeight = (message.triggeredBlockHeight || long_1.default.ZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        message.market !== undefined && (obj.market = message.market);
        message.side !== undefined && (obj.side = message.side);
        message.price !== undefined && (obj.price = message.price);
        message.quantity !== undefined && (obj.quantity = message.quantity);
        message.available !== undefined && (obj.available = message.available);
        message.filled !== undefined && (obj.filled = message.filled);
        message.status !== undefined && (obj.status = message.status);
        message.orderType !== undefined && (obj.orderType = message.orderType);
        message.initiator !== undefined && (obj.initiator = message.initiator);
        message.timeInForce !== undefined &&
            (obj.timeInForce = message.timeInForce);
        message.stopPrice !== undefined && (obj.stopPrice = message.stopPrice);
        message.triggerType !== undefined &&
            (obj.triggerType = message.triggerType);
        message.allocatedMargin !== undefined &&
            (obj.allocatedMargin = message.allocatedMargin
                ? coin_1.Coin.toJSON(message.allocatedMargin)
                : undefined);
        message.isLiquidation !== undefined &&
            (obj.isLiquidation = message.isLiquidation);
        message.isPostOnly !== undefined && (obj.isPostOnly = message.isPostOnly);
        message.isReduceOnly !== undefined &&
            (obj.isReduceOnly = message.isReduceOnly);
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.avgFilledPrice !== undefined &&
            (obj.avgFilledPrice = message.avgFilledPrice);
        message.referralAddress !== undefined &&
            (obj.referralAddress = message.referralAddress);
        message.referralCommission !== undefined &&
            (obj.referralCommission = message.referralCommission);
        message.referralKickback !== undefined &&
            (obj.referralKickback = message.referralKickback);
        message.poolRoute !== undefined &&
            (obj.poolRoute = base64FromBytes(message.poolRoute !== undefined ? message.poolRoute : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        const message = Object.assign({}, baseOrder);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.blockHeight =
            object.blockHeight !== undefined && object.blockHeight !== null
                ? long_1.default.fromValue(object.blockHeight)
                : long_1.default.ZERO;
        message.blockCreatedAt = (_b = object.blockCreatedAt) !== null && _b !== void 0 ? _b : undefined;
        message.triggeredBlockHeight =
            object.triggeredBlockHeight !== undefined &&
                object.triggeredBlockHeight !== null
                ? long_1.default.fromValue(object.triggeredBlockHeight)
                : long_1.default.ZERO;
        message.address = (_c = object.address) !== null && _c !== void 0 ? _c : "";
        message.market = (_d = object.market) !== null && _d !== void 0 ? _d : "";
        message.side = (_e = object.side) !== null && _e !== void 0 ? _e : "";
        message.price = (_f = object.price) !== null && _f !== void 0 ? _f : "";
        message.quantity = (_g = object.quantity) !== null && _g !== void 0 ? _g : "";
        message.available = (_h = object.available) !== null && _h !== void 0 ? _h : "";
        message.filled = (_j = object.filled) !== null && _j !== void 0 ? _j : "";
        message.status = (_k = object.status) !== null && _k !== void 0 ? _k : "";
        message.orderType = (_l = object.orderType) !== null && _l !== void 0 ? _l : "";
        message.initiator = (_m = object.initiator) !== null && _m !== void 0 ? _m : "";
        message.timeInForce = (_o = object.timeInForce) !== null && _o !== void 0 ? _o : "";
        message.stopPrice = (_p = object.stopPrice) !== null && _p !== void 0 ? _p : "";
        message.triggerType = (_q = object.triggerType) !== null && _q !== void 0 ? _q : "";
        message.allocatedMargin =
            object.allocatedMargin !== undefined && object.allocatedMargin !== null
                ? coin_1.Coin.fromPartial(object.allocatedMargin)
                : undefined;
        message.isLiquidation = (_r = object.isLiquidation) !== null && _r !== void 0 ? _r : false;
        message.isPostOnly = (_s = object.isPostOnly) !== null && _s !== void 0 ? _s : false;
        message.isReduceOnly = (_t = object.isReduceOnly) !== null && _t !== void 0 ? _t : false;
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.avgFilledPrice = (_u = object.avgFilledPrice) !== null && _u !== void 0 ? _u : "";
        message.referralAddress = (_v = object.referralAddress) !== null && _v !== void 0 ? _v : "";
        message.referralCommission = (_w = object.referralCommission) !== null && _w !== void 0 ? _w : 0;
        message.referralKickback = (_x = object.referralKickback) !== null && _x !== void 0 ? _x : 0;
        message.poolRoute = (_y = object.poolRoute) !== null && _y !== void 0 ? _y : new Uint8Array();
        return message;
    },
};
const baseDBOrder = {
    allocatedMarginDenom: "",
    allocatedMarginAmount: "",
    username: "",
    lastUpdatedBlockHeight: long_1.default.ZERO,
};
exports.DBOrder = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.order !== undefined) {
            exports.Order.encode(message.order, writer.uint32(10).fork()).ldelim();
        }
        if (message.allocatedMarginDenom !== "") {
            writer.uint32(18).string(message.allocatedMarginDenom);
        }
        if (message.allocatedMarginAmount !== "") {
            writer.uint32(26).string(message.allocatedMarginAmount);
        }
        if (message.username !== "") {
            writer.uint32(34).string(message.username);
        }
        if (!message.lastUpdatedBlockHeight.isZero()) {
            writer.uint32(40).int64(message.lastUpdatedBlockHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDBOrder);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.order = exports.Order.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allocatedMarginDenom = reader.string();
                    break;
                case 3:
                    message.allocatedMarginAmount = reader.string();
                    break;
                case 4:
                    message.username = reader.string();
                    break;
                case 5:
                    message.lastUpdatedBlockHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDBOrder);
        message.order =
            object.order !== undefined && object.order !== null
                ? exports.Order.fromJSON(object.order)
                : undefined;
        message.allocatedMarginDenom =
            object.allocatedMarginDenom !== undefined &&
                object.allocatedMarginDenom !== null
                ? String(object.allocatedMarginDenom)
                : "";
        message.allocatedMarginAmount =
            object.allocatedMarginAmount !== undefined &&
                object.allocatedMarginAmount !== null
                ? String(object.allocatedMarginAmount)
                : "";
        message.username =
            object.username !== undefined && object.username !== null
                ? String(object.username)
                : "";
        message.lastUpdatedBlockHeight =
            object.lastUpdatedBlockHeight !== undefined &&
                object.lastUpdatedBlockHeight !== null
                ? long_1.default.fromString(object.lastUpdatedBlockHeight)
                : long_1.default.ZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.order !== undefined &&
            (obj.order = message.order ? exports.Order.toJSON(message.order) : undefined);
        message.allocatedMarginDenom !== undefined &&
            (obj.allocatedMarginDenom = message.allocatedMarginDenom);
        message.allocatedMarginAmount !== undefined &&
            (obj.allocatedMarginAmount = message.allocatedMarginAmount);
        message.username !== undefined && (obj.username = message.username);
        message.lastUpdatedBlockHeight !== undefined &&
            (obj.lastUpdatedBlockHeight = (message.lastUpdatedBlockHeight || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseDBOrder);
        message.order =
            object.order !== undefined && object.order !== null
                ? exports.Order.fromPartial(object.order)
                : undefined;
        message.allocatedMarginDenom = (_a = object.allocatedMarginDenom) !== null && _a !== void 0 ? _a : "";
        message.allocatedMarginAmount = (_b = object.allocatedMarginAmount) !== null && _b !== void 0 ? _b : "";
        message.username = (_c = object.username) !== null && _c !== void 0 ? _c : "";
        message.lastUpdatedBlockHeight =
            object.lastUpdatedBlockHeight !== undefined &&
                object.lastUpdatedBlockHeight !== null
                ? long_1.default.fromValue(object.lastUpdatedBlockHeight)
                : long_1.default.ZERO;
        return message;
    },
};
const baseOrdersForMarket = { marketId: "" };
exports.OrdersForMarket = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.marketId !== "") {
            writer.uint32(10).string(message.marketId);
        }
        for (const v of message.orders) {
            exports.Order.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseOrdersForMarket);
        message.orders = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketId = reader.string();
                    break;
                case 2:
                    message.orders.push(exports.Order.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseOrdersForMarket);
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.orders = ((_a = object.orders) !== null && _a !== void 0 ? _a : []).map((e) => exports.Order.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.marketId !== undefined && (obj.marketId = message.marketId);
        if (message.orders) {
            obj.orders = message.orders.map((e) => (e ? exports.Order.toJSON(e) : undefined));
        }
        else {
            obj.orders = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseOrdersForMarket);
        message.marketId = (_a = object.marketId) !== null && _a !== void 0 ? _a : "";
        message.orders = ((_b = object.orders) !== null && _b !== void 0 ? _b : []).map((e) => exports.Order.fromPartial(e));
        return message;
    },
};
const baseOrderIDsForMarket = { marketId: "", orderIds: "" };
exports.OrderIDsForMarket = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.marketId !== "") {
            writer.uint32(10).string(message.marketId);
        }
        for (const v of message.orderIds) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseOrderIDsForMarket);
        message.orderIds = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketId = reader.string();
                    break;
                case 2:
                    message.orderIds.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseOrderIDsForMarket);
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.orderIds = ((_a = object.orderIds) !== null && _a !== void 0 ? _a : []).map((e) => String(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.marketId !== undefined && (obj.marketId = message.marketId);
        if (message.orderIds) {
            obj.orderIds = message.orderIds.map((e) => e);
        }
        else {
            obj.orderIds = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseOrderIDsForMarket);
        message.marketId = (_a = object.marketId) !== null && _a !== void 0 ? _a : "";
        message.orderIds = ((_b = object.orderIds) !== null && _b !== void 0 ? _b : []).map((e) => e);
        return message;
    },
};
const baseOrderIDs = { ids: "" };
exports.OrderIDs = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.ids) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseOrderIDs);
        message.ids = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ids.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseOrderIDs);
        message.ids = ((_a = object.ids) !== null && _a !== void 0 ? _a : []).map((e) => String(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ids) {
            obj.ids = message.ids.map((e) => e);
        }
        else {
            obj.ids = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseOrderIDs);
        message.ids = ((_a = object.ids) !== null && _a !== void 0 ? _a : []).map((e) => e);
        return message;
    },
};
const baseOrders = {};
exports.Orders = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.orders) {
            exports.Order.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseOrders);
        message.orders = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.orders.push(exports.Order.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseOrders);
        message.orders = ((_a = object.orders) !== null && _a !== void 0 ? _a : []).map((e) => exports.Order.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orders) {
            obj.orders = message.orders.map((e) => (e ? exports.Order.toJSON(e) : undefined));
        }
        else {
            obj.orders = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseOrders);
        message.orders = ((_a = object.orders) !== null && _a !== void 0 ? _a : []).map((e) => exports.Order.fromPartial(e));
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
const atob = globalThis.atob ||
    ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
const btoa = globalThis.btoa ||
    ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr) {
        bin.push(String.fromCharCode(byte));
    }
    return btoa(bin.join(""));
}
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
